import { useEffect, useState } from 'react';
import { Box, Paper, Typography, Stepper, Step, StepLabel, Alert } from '@mui/material';
import { api } from '../../api/api';

// 점주용 매장 오픈 진행 상황 (12.01-D011, docs/V1_STORE_ONBOARDING_DESIGN.md §7-3)
// 서버 단계(10개)를 점주에게 보이는 7단계로 묶는다 — services/onboardingEmail.js OWNER_STEPS 와 같은 구분
const OWNER_STEPS = [
  { label: '정보 입력', stages: ['applied'] },
  { label: '계약서 서명', stages: ['info_ready', 'contract_sent'] },
  { label: '설치비 입금', stages: ['contract_signed'] },
  { label: 'ACH 자동이체 등록', stages: ['setup_paid'] },
  { label: '기기 배송', stages: ['ach_ready', 'shipped'] },
  { label: '설치', stages: ['delivered', 'installing'] },
  { label: '오픈', stages: ['open'] },
];
const OWNER_TODO = {
  applied: '매장·연락처 정보를 입력해 주세요 (초대 메일의 링크).',
  info_ready: 'Digntec 이 계약서와 설치비 안내를 준비하고 있습니다.',
  contract_sent: '메일로 받은 계약서에 서명해 주세요.',
  contract_signed: '설치비를 입금해 주세요.',
  setup_paid: '첫 달 요금부터 사용할 ACH 자동이체를 등록해 주세요.',
  ach_ready: 'Digntec 이 기기 발송을 준비하고 있습니다.',
  shipped: '기기가 배송 중입니다.',
  delivered: '설치 일정을 Digntec 과 맞춰 주세요.',
  installing: '설치 중입니다. 화면 확인 후 오픈합니다.',
};

function OnboardingProgress({ storeId, storeName }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!storeId) return;
    api.get(`/onboarding/stores/${storeId}`).then(({ data }) => setD(data)).catch(() => setD(null));
  }, [storeId]);
  if (!d || d.lifecycle !== 'onboarding' || !d.summary) return null;
  const stage = d.summary.stage;
  const active = Math.max(0, OWNER_STEPS.findIndex((s) => s.stages.includes(stage)));
  return (
    <Paper sx={{ p: 2, mb: 2, borderRadius: 3, border: '1px solid #E0D7FF' }}>
      <Typography sx={{ fontWeight: 700, mb: 1.5 }}>매장 오픈 진행 상황{storeName ? ` — ${storeName}` : ''}</Typography>
      <Box sx={{ overflowX: 'auto', pb: 1 }}>
        <Stepper activeStep={active} alternativeLabel sx={{ minWidth: 560 }}>
          {OWNER_STEPS.map((s) => (
            <Step key={s.label}><StepLabel>{s.label}</StepLabel></Step>
          ))}
        </Stepper>
      </Box>
      {OWNER_TODO[stage] && <Alert severity="info" sx={{ mt: 1 }}>다음: {OWNER_TODO[stage]}</Alert>}
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
        문의 support@digntec.com · (201) 357-7222
      </Typography>
    </Paper>
  );
}

export default OnboardingProgress;
